import React from 'react';
import { Switch, Route } from 'react-router-dom';
import UserDetails from './UserDetails';
import FileUpload from './FileUpload';
import HeaderMapping from './HeaderMapping'
import VendorNavigation from './VendorNavigation'
import DirectMatchTruck from './DirectMatchTruck';
import SpellCorrectionTruck from './SpellCorrectionTruck';
import DirectMatchVendor from './DirectMatchVendor';
import SpellCorrectionVendor from './SpellCorrectionVendor';
import FinalConsolidation from './FinalConsolidation'
import UniqueLocation from './UniqueLocation';
import MultipleLocation from './MultipleLocation';
import SpellCorrectionLocation from './SpellCorrectionLocation'
import ManualLocation from './ManualLocation'
import Summary from './Summary';
import Login from './Login/Login';
import ReviewScreen from './ReviewScreen/ReviewScreen';
import DataUpload from './DataUpload/DataUpload';

const RouteOutlet = () => {
    return (
        <Switch>
            {/* Root component */}
            <Route path="/" component={UserDetails} exact />
            {/* User Details  */}
            <Route path="/user_details" component={UserDetails} exact />
            {/* Upload screen */}
            <Route path="/file_upload" component={FileUpload} exact />
            {/* Header Mapping */}
            <Route path="/header_mapping" component={HeaderMapping} />
            {/* Unique Location User Approval */}
            <Route path="/uniqueLocation" component={UniqueLocation} />
            {/* Multiple Locations */}
            <Route path="/multiLocation" component={MultipleLocation} />
            {/* Location Spell Correction */}
            <Route path="/spellCorrectionLocation" component={SpellCorrectionLocation} />
            {/* Manual Location Input */}
            <Route path="/manualLocation" component={ManualLocation} />
            {/* Direct Match for Vendors Screen */}
            <Route path="/directMatchVendor" component={DirectMatchVendor} />
            {/* Spell Correction for Vendors Screen */}
            <Route path="/spellCorrectionVendor" component={SpellCorrectionVendor} />
            {/* Direct Match for Truck Screen */}
            <Route path="/directMatchTruck" component={DirectMatchTruck} />
            {/* Spell Correction for Truck Screen */}
            <Route path="/spellCorrectionTruck" component={SpellCorrectionTruck} />
            {/* Final Consolidation Screen */}
            <Route path="/FinalConsolidation" component={FinalConsolidation} />
            {/* Summary Screen */}
            <Route path="/summaryScreen" component={Summary} />
            {/* Navigation Screen */}
            <Route path="/vendor_navigation" component={VendorNavigation} />
            {/* Review Screen */}
            <Route path="/review-screen" component={ReviewScreen} />
            <Route path='/dataUploadSection' component={DataUpload} />
        </Switch>
    )
}

export default RouteOutlet
